import {connect} from 'react-redux';
import SEOTextComponent from './SEOText';

export function mapStateToProps({config: {isRefined}, content}) {
    return {
        isRefined,
        slpText: isRefined ? content.slpRefinedText : content.slpText,
    };
}

export const SEOText = connect(mapStateToProps)(SEOTextComponent);

SEOText.displayName = 'SEOText';

export default SEOText;
